// extracted by mini-css-extract-plugin
export default {"didYouFinance":"responsiveStyles_didYouFinance__F-ZJW","didYouFinanceInner":"responsiveStyles_didYouFinanceInner__SQX+P"};